<template>
  <div>
    <el-row class="cs-search-conditions">
      <el-col :span="4">
        <el-select placeholder="课程类型" size="medium" :disabled="loading" v-model="searchCondition.courseType" @change="onCourseTypeChange">
          <el-option v-for="item in scPreloadData.courseTypeItems" :key="item.value" :label="item.desc" :value="item.value" />
        </el-select>
      </el-col>
      <div class="cs-content-group" v-if="searchCondition.courseType === GLOBAL.courseType.university">
        <el-col :span="4">
          <el-select class="margin-left-20px" placeholder="学校" size="medium" :disabled="loading" v-model="searchCondition.groupNumber"
            @change="onGroupNumberChange">
            <el-option v-for="item in scPreloadData.universityGroups" :key="item.IdValue" :label="item.NameValue" :value="item.GroupNumber" />
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select class="margin-left-20px" placeholder="学期" size="medium" :disabled="loading" v-model="searchCondition.termId" @change="onTermIdChange">
            <el-option v-for="item in scPreloadData.termList" :key="item.Id" :label="item.DisplayLable" :value="item.Id" />
          </el-select>
        </el-col>
      </div>
      <div class="cs-content-group" v-if="searchCondition.courseType === GLOBAL.courseType.vocationalTraining">
        <el-col :span="4">
          <el-select class="margin-left-20px" placeholder="职业类型" size="medium" :disabled="loading" v-model="searchCondition.trainingCourseCategory"
            @change="onTrainingCourseCategoryChange">
            <el-option v-for="item in scPreloadData.trainingCourseCategories" :key="item.Id" :label="item.Name" :value="item.Id" />
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select class="margin-left-20px" placeholder="学期" size="medium" :disabled="loading" v-model="searchCondition.trainingTermId"
            @change="onTrainingTermIdChange">
            <el-option v-for="item in trainingTermList" :key="item.Id" :label="item.DisplayLable" :value="item.Id" />
          </el-select>
        </el-col>
      </div>
      <el-col :span="4">
        <el-select class="margin-left-20px" placeholder="课程" size="medium" :disabled="loading" filterable v-model="searchCondition.courseId"
          @change="onCourseIdChange">
          <el-option v-for="item in courseList" :key="item.Id" :label="item.Name" :value="item.Id" />
        </el-select>
      </el-col>
      <el-col :span="4" class="padding-left-20px">
        <el-checkbox size="medium" :disabled="loading" v-model="searchCondition.isVideoCourseRemoved" class="cs-isVideoCourseRemoved"
          @change="onIsVideoCourseRemovedChange">去除视频课</el-checkbox>
      </el-col>
      <el-col :span="4" class="cs-signInQuery-buttons">
        <el-button type="primary" :disabled="loading" size="medium" @click="onSearch">搜索</el-button>
      </el-col>
    </el-row>
    <el-row class="cs-search-conditions">
      <el-col :span="4">
        <el-select placeholder="周" size="medium" :disabled="loading" filterable v-model="searchCondition.week" @change="onWeekChange">
          <el-option :key="0" label="所有周" :value="0" />
          <el-option v-for="item in weekList" :key="item.Week" :label="item.Label" :value="item.Week" />
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-date-picker align="center" class="margin-left-20px cs-signInQuery-searchDate" :picker-options="pickerOptions" :disabled="loading"
          v-model="searchCondition.searchDate" type="date" placeholder="结束日期(可选)" size="medium"></el-date-picker>
      </el-col>
      <el-col v-if="searchCondition.courseType === GLOBAL.courseType.vocationalTraining" :span="4">
        <el-select class="margin-left-20px" placeholder="校区" size="medium" :disabled="loading" filterable v-model="searchCondition.campusId"
          @change="onCampusIdChange">
          <el-option :key="0" label="所有校区" :value="0" />
          <el-option v-for="item in courseCampusList" :key="item.Id" :label="item.Name" :value="item.Id" />
        </el-select>
      </el-col>
      <el-col v-show="showIsYearCourseMerged" :span="4" class="padding-left-20px">
        <el-checkbox size="medium" :disabled="loading" v-model="searchCondition.isYearCourseMerged" class="cs-isYearCourseMerged"
          @change="onIsYearCourseMergedChange">合并年课</el-checkbox>
      </el-col>
      <el-col :span="4" class="padding-left-20px">
        <el-select placeholder="视频分钟数" size="medium" :disabled="loading" v-model="searchCondition.watchMinutes" @change="onWatchMinutesChange">
          <el-option v-for="item in watchMinuteItems" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-col>
    </el-row>

    <pagination v-loading="loading" :data="signInListData" :option="paginationOption">
      <template #YearCourseType="{row}">
        <span>{{GLOBAL.enumYearCourseType.getDesc(row.YearCourseType)}}</span>
      </template>
    </pagination>

    <el-row class="">
      <br />
      1. 该查询用来查阅大学每个课程学生的单独出勤率<br />
      2. 用途：教务总监和助理计算老师每个课程学生出勤情况<br />
      3. 计算规则：<br />
      a. 默认: 在选择的截止周范围内，出勤率 = (学生签到课程总分钟数 - 缺时总分钟数) / 课程总分钟数<br />
      b. 计算视频课：在选择的截止周范围内，出勤率为<br />
      i. 分子计算法则：学生签到的课程，为签到总课程分钟数 - 总缺时分钟数. 若学生旷课，缺课或者为视频课，在观看视频总分钟大于等于100分钟(选中的看视频分钟数)，算作该课节出勤。否则算旷课。<br />
      ii. 分母计算法则： 课程总分钟数

    </el-row>
  </div>
</template>

<script>
import { getDatePart } from "@/config/mUtils";
import pagination from "@/components/common/pagination";

import { downloadFile } from "@/config/mUtils";
import {
  getTrainingTerms,
  getCourseCampusList,
} from "@/service/common.service";
import { getCoursesInTerm } from "@/service/speedupCourse.service";
import { getWeekList } from "@/service/termManage.service";
import {
  getSignInQueryListByCourse,
  exportSignInQueryListByCourse,
} from "@/service/signInManage.service";
import { formatDate } from "../../config/mUtils";

const defaultValues = {
  signInListData: {
    Columns: [],
    Results: [],
  },
};

import { mixinSignInQuery } from "./mixinSignInQuery";
export default {
  name: "signInQueryList2",
  mixins: [mixinSignInQuery],
  components: {
    pagination,
  },
  props: {
    colOptions: {
      type: Object,
      default: function () {
        return {
          lgSize: 5,
          mdSize: 8,
          smSize: 24,
        };
      },
    },
    queryType: {
      type: String,
      required: true,
    },
    scPreloadData: {
      type: Object,
      default: () => {
        return {
          defaultValues: {},
          termList: [],
          universityGroups: [],
          trainingCourseCategories: [],
        };
      },
    },
    paginationOption: {
      typeof: Object,
      default: () => {
        return {
          displayPagination: false,
          hasEditButton: false,
          editButtonText: String.empty,
          hasAddButton: false,
          addButtonText: String.empty,
          hasSearch: false,
          editColumnTite: String.empty,
          showAcitveColor: true,
          hideDisableRow: true,
          showYearCourseType: false,
        };
      },
    },
  },
  data() {
    return {
      loading: false,
      isDataReady: false,
      searchCondition: {
        courseType: 1,
        groupNumber: null,
        termId: null,
        trainingCourseCategory: null,
        trainingTermId: null,
        courseId: null,
        campusId: null,
        week: null,
        isVideoCourseRemoved: false,
        isYearCourseMerged: false,
        searchDate: "",
        watchMinutes: 80,
      },
      trainingTermList: [],
      courseList: [],
      courseCampusList: [],
      weekList: [],
      signInListData: defaultValues.signInListData,
      pickerOptions: {
        firstDayOfWeek: 1,
      },
      watchMinuteItems: [],
    };
  },
  created() {
    this.loadWatchMinuteItems();
  },
  computed: {
    canExport() {
      if (this.queryType !== "2" || !this.isDataReady) return false;

      if (
        this.searchCondition.courseType ===
          this.GLOBAL.courseType.vocationalTraining &&
        this.signInListData.Results.length === 0
      )
        return false;

      if (this.signInListData.Results.length === 0) return false;

      return true;
    },
    showIsYearCourseMerged() {
      if (this.searchCondition.courseType !== this.GLOBAL.courseType.university)
        return false;

      let course = this.courseList.find(
        (item) => item.Id === this.searchCondition.courseId
      );
      if (!course || !course.IsYearCourse) return false;

      let term = this.scPreloadData.termList.find(
        (item) => item.Id === this.searchCondition.termId
      );
      if (!term) return false;

      let termStartMonth = getDatePart(term.StartDate, "month");
      let termEndMonth = getDatePart(term.EndDate, "month");
      if (
        (termStartMonth == course.StartMonth &&
          termEndMonth === course.EndMonth) ||
        termEndMonth !== course.EndMonth
      )
        return false;

      return true;
    },
  },
  methods: {
    loadWatchMinuteItems() {
      if (this.searchCondition.courseType === 1) {
        this.watchMinuteItems = [
          { label: "看视频分钟数(100)", value: 100 },
          { label: "看视频分钟数(80)", value: 80 },
          { label: "看视频分钟数(60)", value: 60 },
          { label: "看视频分钟数(25%)", value: 0.25 },
          { label: "排除看视频", value: 9999 },
        ];
      } else {
        this.watchMinuteItems = [
          { label: "看视频分钟数(100)", value: 100 },
          { label: "看视频分钟数(80)", value: 80 },
          { label: "看视频分钟数(60)", value: 60 },
          { label: "排除看视频", value: 9999 },
        ];
      }
      this.searchCondition.watchMinutes = 80;
    },
    async loadTrainingTermsFromServer() {
      if (
        this.queryType !== "2" ||
        this.searchCondition.courseType !==
          this.GLOBAL.courseType.vocationalTraining
      )
        return;

      let result = await getTrainingTerms(
        false,
        this.searchCondition.trainingCourseCategory
      );
      this.trainingTermList = !!result && result.success ? result.data : [];
      if (this.searchCondition._fromStore) return;

      let currentTerm = null;
      if (this.trainingTermList.length > 0) {
        currentTerm = this.trainingTermList.find((i) => i.IsCurrentTerm);
        if (!currentTerm) currentTerm = this.trainingTermList[0];
      }
      this.searchCondition.trainingTermId = !!currentTerm
        ? currentTerm.Id
        : null;
    },
    async loadCoursesInTermFromServer() {
      if (this.queryType !== "2") return;

      let courseType = this.searchCondition.courseType;
      let termId =
        courseType !== this.GLOBAL.courseType.vocationalTraining
          ? this.searchCondition.termId
          : this.searchCondition.trainingTermId;
      let universityGroup =
        courseType !== this.GLOBAL.courseType.vocationalTraining
          ? this.searchCondition.groupNumber
          : 0;

      let result = await getCoursesInTerm(termId, universityGroup, courseType);
      let courseList = !!result && result.success ? result.data : [];
      let currentCourse = null;
      if (courseList.length > 0) {
        currentCourse = courseList[0];
      }
      this.courseList = courseList;
      if (this.searchCondition._fromStore) return;

      this.searchCondition.courseId = !!currentCourse ? currentCourse.Id : null;

      this.searchCondition.isYearCourseMerged = this.showIsYearCourseMerged
        ? true
        : false;
    },
    async loadCourseCampusListFromServer() {
      if (
        this.queryType !== "2" ||
        this.searchCondition.courseType !==
          this.GLOBAL.courseType.vocationalTraining
      )
        return;

      let result = await getCourseCampusList(this.searchCondition.courseId);
      this.courseCampusList = !!result && result.success ? result.data : [];
      if (this.searchCondition._fromStore) return;

      this.searchCondition.campusId = 0;
    },
    async loadTermWeekListFromServer() {
      if (this.queryType !== "2") return;

      let termId =
        this.searchCondition.courseType !==
        this.GLOBAL.courseType.vocationalTraining
          ? this.searchCondition.termId
          : this.searchCondition.trainingTermId;

      let result = await getWeekList(termId, false, true);
      this.weekList = !!result && result.success ? result.data : [];
      if (this.searchCondition._fromStore) return;

      this.searchCondition.week = 0;
    },
    async loadSignInQueryListByCourseFromServer() {
      if (this.queryType !== "2") return;

      let courseType = this.searchCondition.courseType;
      let termId =
        courseType !== this.GLOBAL.courseType.vocationalTraining
          ? this.searchCondition.termId
          : this.searchCondition.trainingTermId;
      let courseId = this.searchCondition.courseId;

      if (!courseType || !termId || !courseId) {
        this.signInListData = defaultValues.signInListData;
        return;
      }
      if (!this.validateSearchDate()) {
        return;
      }
      let searchDate = this.getSearchDate();
      let isYearCourseMerged =
        this.showIsYearCourseMerged && this.searchCondition.isYearCourseMerged;
      this.loading = true;
      let result = await getSignInQueryListByCourse(
        courseType,
        termId,
        courseId,
        this.searchCondition.week,
        searchDate,
        this.searchCondition.isVideoCourseRemoved,
        isYearCourseMerged,
        this.searchCondition.watchMinutes
      );
      this.signInListData =
        !!result && result.success ? result.data : defaultValues.signInListData;
      this.$set(
        this.paginationOption,
        "showYearCourseType",
        this.searchCondition.isYearCourseMerged
      );
      this.updateSignInQueryAll({
        queryType: this.queryType,
        searchCondition: this.searchCondition,
      });
      this.$set(this.searchCondition, "_fromStore", false);
      this.loading = false;
    },
    async exportSignInQueryListFromServer() {
      if (this.queryType !== "2") return;

      let courseType = this.searchCondition.courseType;
      let termId =
        courseType !== this.GLOBAL.courseType.vocationalTraining
          ? this.searchCondition.termId
          : this.searchCondition.trainingTermId;
      let courseId = this.searchCondition.courseId;

      if (!courseType || !termId || !courseId) {
        this.signInListData = defaultValues.signInListData;
        return;
      }
      if (!this.validateSearchDate()) {
        return;
      }
      let searchDate = this.getSearchDate();
      let isYearCourseMerged =
        this.showIsYearCourseMerged && this.searchCondition.isYearCourseMerged;
      this.loading = true;
      let result = await exportSignInQueryListByCourse(
        courseType,
        termId,
        courseId,
        this.searchCondition.groupNumber,
        this.searchCondition.trainingCourseCategory,
        this.searchCondition.campusId,
        this.searchCondition.week,
        searchDate,
        this.searchCondition.isVideoCourseRemoved,
        isYearCourseMerged,
        this.searchCondition.watchMinutes
      );
      if (!!result && result.success) {
        downloadFile(result);
      }
      this.loading = false;
    },
    onCourseTypeChange() {
      this.$nextTick(async () => {
        this.loadWatchMinuteItems();
        await this.loadTrainingTermsFromServer();
        await this.loadCoursesInTermFromServer();
        await this.loadCourseCampusListFromServer();
        await this.loadTermWeekListFromServer();
      });
    },
    onGroupNumberChange() {
      this.$nextTick(async () => {
        await this.loadCoursesInTermFromServer();
      });
    },
    onTermIdChange() {
      this.$nextTick(async () => {
        await this.loadCoursesInTermFromServer();
        await this.loadTermWeekListFromServer();
      });
    },
    onTrainingCourseCategoryChange() {
      this.$nextTick(async () => {
        await this.loadTrainingTermsFromServer();
        await this.loadCoursesInTermFromServer();
        await this.loadTermWeekListFromServer();
      });
    },
    onTrainingTermIdChange() {
      this.$nextTick(async () => {
        await this.loadCoursesInTermFromServer();
        await this.loadTermWeekListFromServer();
      });
    },
    onCourseIdChange() {
      this.$nextTick(async () => {
        await this.loadCourseCampusListFromServer();

        this.searchCondition.isYearCourseMerged = this.showIsYearCourseMerged
          ? true
          : false;
      });
    },
    onCampusIdChange() {},
    onWeekChange() {},
    onIsVideoCourseRemovedChange() {},
    onIsYearCourseMergedChange() {},
    onSearch() {
      this.loadSignInQueryListByCourseFromServer();
    },
    onWatchMinutesChange() {},
    getSearchDate() {
      let date = "";
      if (this.searchCondition.searchDate) {
        date = formatDate(this.searchCondition.searchDate);
      }
      return date;
    },
    validateSearchDate() {
      if (this.searchCondition.week && this.searchCondition.searchDate) {
        let weekItem = this.weekList.find(
          (i) => i.Week == this.searchCondition.week
        );
        if (weekItem) {
          let startDate = new Date(weekItem.StartDate);
          let endDate = new Date(weekItem.EndDate);
          if (
            this.searchCondition.searchDate < startDate ||
            this.searchCondition.searchDate > endDate
          ) {
            let searchDate = this.getSearchDate();
            let msg = `结束日期${searchDate}需要在当前选择周${weekItem.Label}的日期范围内`;
            this.$message.error(msg);
            return false;
          }
        }
      }
      return true;
    },
  },
  watch: {
    queryType(newValue, oldValue) {
      if (newValue == "2") {
        if (this.isDataReady) {
          this.updateSignInQueryAll({
            queryType: newValue,
            searchCondition: this.searchCondition,
          });
          return;
        } else {
          this.updateQueryType(newValue);
        }
      } else {
        return;
      }

      this.$nextTick(async () => {
        let storeSearchConditionValue = this.storeSearchCondition;
        if (!!storeSearchConditionValue) {
          this.searchCondition = storeSearchConditionValue;
          this.$set(this.searchCondition, "_fromStore", true);
        }

        await this.loadTrainingTermsFromServer();
        await this.loadCoursesInTermFromServer();
        await this.loadCourseCampusListFromServer();
        await this.loadTermWeekListFromServer();
        await this.loadSignInQueryListByCourseFromServer();
        this.isDataReady = true;
      });
    },
    scPreloadData(newValue, oldValue) {
      Object.copy(
        this.searchCondition,
        { onlyFieldExists: true },
        newValue.defaultValues
      );

      if (this.queryType != "2") return;

      this.$nextTick(async () => {
        let storeSearchConditionValue = this.storeSearchCondition;
        if (!!storeSearchConditionValue) {
          this.searchCondition = storeSearchConditionValue;
          this.$set(this.searchCondition, "_fromStore", true);
        }

        await this.loadTrainingTermsFromServer();
        await this.loadCoursesInTermFromServer();
        await this.loadCourseCampusListFromServer();
        await this.loadTermWeekListFromServer();
        await this.loadSignInQueryListByCourseFromServer();
        this.isDataReady = true;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.cs-search-conditions {
  .el-col {
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .cs-signInQuery-searchDate {
    width: auto;
  }
}

.cs-isVideoCourseRemoved,
.cs-isYearCourseMerged {
  line-height: 36px;
  margin-bottom: 0;
  margin-left: 5px;
}

.cs-signInQuery-buttons {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/signInManage/signInQueryList2.vue